// extracted by mini-css-extract-plugin
export default {"SiteLightBlue":"#0B7EB5","Main":"Tooltip_Main__gh73D","Icon":"Tooltip_Icon__FJ3mi"};